import { AUTH_USER_FRAGMENT } from 'features/user/api/authUser'
import { ERROR_FRAGMENT } from 'providers/tanstack-query/errors'
import { gql } from 'providers/tanstack-query/utils'

import type { Data, Variables } from './types'
import type { Ability } from 'providers/casl'
import type { TypedDocumentNode } from 'providers/tanstack-query/types'

export const CONFIRM_USER = (
  ability: Ability,
): TypedDocumentNode<Data, { input: Variables }> => gql`
  ${AUTH_USER_FRAGMENT(ability)}
  ${ERROR_FRAGMENT}

  mutation confirmUser($input: ConfirmUserInput!) {
    confirmUser(input: $input) {
      accessToken
      refreshToken

      user {
        ...AuthUserFragment
      }

      errors {
        ...ErrorFragment
      }
    }
  }
`
